import type { Status } from "./types";
import { cn } from "./utils";

const TONE: Record<Status, string> = {
  live: "border-transparent bg-ok-soft text-ok",
  soon: "border-transparent bg-accent-soft text-accent",
  plan: "border-line text-fg-muted",
};

const DOT: Record<Status, string> = {
  live: "dot-live bg-current",
  soon: "bg-current",
  // Hollow dot: planned is not happening yet.
  plan: "border border-current",
};

export function StatusPill({ status, label }: { status: Status; label: string }) {
  return (
    <span
      className={cn(
        "inline-flex h-[22px] shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full border px-2.5 font-mono text-[10.5px] font-medium uppercase tracking-[0.08em]",
        TONE[status],
      )}
    >
      <span aria-hidden className={cn("size-1.5 rounded-full", DOT[status])} />
      {label}
    </span>
  );
}
